import { render, staticRenderFns } from "./NewsThumb.vue?vue&type=template&id=20abee2a&scoped=true&"
import script from "./NewsThumb.vue?vue&type=script&lang=js&"
export * from "./NewsThumb.vue?vue&type=script&lang=js&"
import style0 from "./NewsThumb.vue?vue&type=style&index=0&id=20abee2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20abee2a",
  null
  
)

export default component.exports